import { createSelector } from 'reselect'
import FilterOption from '../../../entities/FilterOption'
import modelsSelector from './modelsSelector'
import filterListSelector from '../filterListSelector'
import filtersSelector from '../filtersSelector'
import modelsPageFiltersEnabledSelector from '../modelsPageFiltersEnabledSelector'

const modelFilterOptionsSelector = createSelector(
    filterListSelector,
    modelsSelector,
    filtersSelector,
    modelsPageFiltersEnabledSelector,
    (filterList, models, appliedFilters, modelsPageFiltersEnabled): FilterOption[] => {
        if (!modelsPageFiltersEnabled || !filterList || !models) {
            return []
        }

        const filterOptions = filterList
            .filter((filter) => models.some(model => 
                model.attributes.some(attr => attr.id === filter.attribute),
            ))
            .map((filter) => {
                const values = new Set<string | number>()
                const activeValues = appliedFilters[filter.attribute] || []
                const otherActiveFilters = Object.entries(appliedFilters)

                const availableModels = models.filter((model) => {
                    return otherActiveFilters.every(([filterKey, filterValues]) => {
                        if (filterValues.length === 0 || filterKey === filter.attribute) {
                            return true
                        }
                        
                        const modelAttribute = model.attributes.find(attr => attr.id === filterKey)
                        if (!modelAttribute) {
                            return false
                        }

                        const otherFilterConfig = filterList.find(f => f.attribute === filterKey)
                        
                        if (otherFilterConfig?.type === 'max') {
                            const numericModelValue = parseFloat(modelAttribute.value.toString())
                            const selectedMaxValue = filterValues[0]
                            const numericMaxValue = typeof selectedMaxValue === 'string' ? parseFloat(selectedMaxValue) : selectedMaxValue
                            
                            return !isNaN(numericModelValue) && 
                                   !isNaN(numericMaxValue) &&
                                   numericModelValue <= numericMaxValue
                        }
                        
                        return filterValues.includes(modelAttribute.value)
                    })
                })

                availableModels.forEach((model) => {
                    const modelAttribute = model.attributes.find(attr => attr.id === filter.attribute)
                    if (modelAttribute) {
                        if (filter.type === 'max') {
                            const numValue = parseFloat(modelAttribute.value.toString())
                            if (!isNaN(numValue)) {
                                values.add(numValue)
                            } else {
                                values.add(modelAttribute.value)
                            }
                        } else {
                            values.add(modelAttribute.value)
                        }
                    }
                })

                return {
                    attribute: filter.attribute,
                    type: filter.type,
                    values: Array.from(values),
                    activeValues,
                }
            })

        return filterOptions
    },
)

export default modelFilterOptionsSelector
